export enum GridDatePeriodType {
  UPCOMING = "upcoming",
  PAST = "past",
}
